export const BANNER_SHOW_REQUEST = "BANNER_SHOW_REQUEST"
export const BANNER_SHOW_SUCCESS = "BANNER_SHOW_SUCCESS"
export const BANNER_SHOW_FAIL = "BANNER_SHOW_FAIL"